// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var MathUtils = require("../../../../shared/src/MathUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var WebTypes_ToDo = require("../../types/WebTypes_ToDo.bs.js");
var WebTypes_View = require("../../types/WebTypes_View.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Shift = require("../../../../shared/src/types/CommonTypes_Shift.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var CommonTypes_User_Name = require("../../../../shared/src/types/CommonTypes_User_Name.bs.js");
var CommonTypes_Worker_Id = require("../../../../shared/src/types/worker/CommonTypes_Worker_Id.bs.js");
var BrowserComponents_Icon = require("../../../../shared-browser/src/components/BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Image = require("../../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Input = require("../../../../shared-browser/src/components/BrowserComponents_Input.bs.js");
var BrowserComponents_Modal = require("../../../../shared-browser/src/components/BrowserComponents_Modal.bs.js");
var CommonTypes_WorkerShift = require("../../../../shared/src/types/CommonTypes_WorkerShift.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var WebComponents_ToDoTaskCard = require("../../components/WebComponents_ToDoTaskCard.bs.js");
var BrowserComponents_WithModal = require("../../../../shared-browser/src/components/BrowserComponents_WithModal.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var BrowserBindings_ReactHotToast = require("../../../../shared-browser/src/bindings/BrowserBindings_ReactHotToast.bs.js");
var WebComponents_ToDoShiftNavigation = require("../../components/WebComponents_ToDoShiftNavigation.bs.js");
var WebComponents_ToDoWorkerShiftList = require("../../components/WebComponents_ToDoWorkerShiftList.bs.js");
var BrowserComponents_AlertCountIndicator = require("../../../../shared-browser/src/components/BrowserComponents_AlertCountIndicator.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.flexEnd),
      tl: /* [] */0
    });

var noTipsEarnedText = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Grey */2,
            _0: /* Medium */2
          }),
      tl: /* [] */0
    });

function arg(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Small */2, /* Semibold */1);
}

var errorText = Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
          hd: BrowserStyle.color({
                TAG: /* Red */5,
                _0: /* Medium */2
              }),
          tl: {
            hd: BrowserStyle.textAlign("right"),
            tl: /* [] */0
          }
        }));

var Styles = {
  container: container,
  noTipsEarnedText: noTipsEarnedText,
  errorText: errorText
};

function WebContainers_BusinessDashboard_ToDo_PayTips$Content$TipsEarnedInput(Props) {
  var setTipAmount = Props.setTipAmount;
  var tipAmount = Props.tipAmount;
  var tmp;
  if (tipAmount !== undefined) {
    if (tipAmount) {
      var value = tipAmount._0;
      var tmp$1 = {
        onChange: setTipAmount,
        size: /* Small */1,
        value: value
      };
      var tmp$2 = Curry._2(Relude_Int.OrdNamed.greaterThan, 40000, value) ? Relude_Option.pure(Relude_Result.error("")) : undefined;
      if (tmp$2 !== undefined) {
        tmp$1.validationStatus = Caml_option.valFromOption(tmp$2);
      }
      tmp = React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Input.AmountCents.make, tmp$1), Curry._2(Relude_Int.OrdNamed.greaterThan, 40000, value) ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Small */3
                    }), React.createElement(BrowserComponents_Text.make, {
                      className: errorText,
                      children: "Cannot input more than " + MathUtils.formatCentsToMoney(40000)
                    })) : null);
    } else {
      tmp = React.createElement(BrowserComponents_FlexRow.make, {
            children: null
          }, React.createElement(BrowserComponents_Icon.make, {
                color: {
                  TAG: /* Grey */2,
                  _0: /* Medium */2
                },
                icon: {
                  TAG: /* Small */1,
                  _0: {
                    TAG: /* Status */8,
                    _0: /* CircleBlock */3
                  }
                }
              }), React.createElement(BrowserComponents_Spacer.make, {
                size: /* Small */3
              }), React.createElement(BrowserComponents_Text.make, {
                className: noTipsEarnedText,
                children: "No tips earned"
              }));
    }
  } else {
    tmp = React.createElement(BrowserComponents_Input.AmountCents.make, {
          onChange: setTipAmount,
          size: /* Small */1,
          value: undefined
        });
  }
  return React.createElement(BrowserComponents_FlexColumn.make, {
              className: container,
              children: tmp
            });
}

var TipsEarnedInput = {
  Styles: Styles,
  make: WebContainers_BusinessDashboard_ToDo_PayTips$Content$TipsEarnedInput
};

function row(rowIndex) {
  var arg = function (param, param$1, param$2) {
    return BrowserStyle.withFont(param, param$1, param$2, /* Semibold */1);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined, undefined), {
                  hd: BrowserStyle.alignItems(BrowserStyle.center),
                  tl: {
                    hd: BrowserStyle.backgroundColor(Relude_Int.eq(0, MathUtils.modulo(2, rowIndex)) ? /* Transparent */2 : ({
                              TAG: /* White */7,
                              _0: /* Dark */0
                            })),
                    tl: {
                      hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.25)),
                      tl: {
                        hd: BrowserStyle.padding2(BrowserStyle.Spacing.small, BrowserStyle.Spacing.large),
                        tl: /* [] */0
                      }
                    }
                  }
                }));
}

var workerName = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: /* [] */0
    });

function arg$1(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Small */2, /* Normal */0);
}

var noTipsEarned = Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined, undefined), {
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Medium */2
              }),
          tl: {
            hd: BrowserStyle.textAlign("right"),
            tl: /* [] */0
          }
        }));

var Styles$1 = {
  row: row,
  workerName: workerName,
  noTipsEarned: noTipsEarned
};

function WebContainers_BusinessDashboard_ToDo_PayTips$Content$WorkerTipsRow(Props) {
  var rowIndex = Props.rowIndex;
  var tipAmount = Props.tipAmount;
  var workerName$1 = Props.workerName;
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: row(rowIndex),
              children: null
            }, React.createElement(BrowserComponents_Text.make, {
                  className: workerName,
                  children: CommonTypes_User_Name.toString(workerName$1)
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Small */3
                }), tipAmount ? React.createElement(BrowserComponents_Text.make, {
                    children: MathUtils.formatCentsToMoney(tipAmount._0)
                  }) : React.createElement(BrowserComponents_Text.make, {
                    className: noTipsEarned,
                    children: "No tips earned"
                  }));
}

var WorkerTipsRow = {
  Styles: Styles$1,
  make: WebContainers_BusinessDashboard_ToDo_PayTips$Content$WorkerTipsRow
};

var errorText$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Red */5,
            _0: /* Medium */2
          }),
      tl: /* [] */0
    });

var Styles$2 = {
  errorText: errorText$1
};

function WebContainers_BusinessDashboard_ToDo_PayTips$Content$Modals$ConfirmLargeTipAmountsContent(Props) {
  var hideModal = Props.hideModal;
  var showModal = Props.showModal;
  var tipAmounts = Props.tipAmounts;
  return React.createElement(BrowserComponents_Modal.Message.make, {
              children: React.createElement(BrowserComponents_FlexColumn.make, {
                    children: null
                  }, React.createElement(BrowserComponents_Text.make, {
                        children: "You are about to pay the following Professionals over $250 in tips each. Please confirm this is correct."
                      }), React.createElement(BrowserComponents_Spacer.make, {
                        size: /* Medium */4
                      }), Relude_Array.mapWithIndex((function (param, rowIndex) {
                          return React.createElement(WebContainers_BusinessDashboard_ToDo_PayTips$Content$WorkerTipsRow, {
                                      rowIndex: rowIndex,
                                      tipAmount: param[1],
                                      workerName: param[0].workerName,
                                      key: Relude_Int.toString(rowIndex)
                                    });
                        }), Relude_Array.keep((function (param) {
                              var tipAmount = param[1];
                              if (tipAmount) {
                                return Curry._2(Relude_Int.OrdNamed.greaterThan, 25000, tipAmount._0);
                              } else {
                                return false;
                              }
                            }), tipAmounts))),
              primaryButton: {
                disabled: false,
                onClick: Curry._1(showModal, /* ConfirmPayoutAmounts */1),
                title: "Confirm"
              },
              secondaryButton: {
                disabled: false,
                onClick: hideModal,
                title: "Cancel"
              },
              title: "Warning",
              titleIcon: {
                TAG: /* Status */8,
                _0: /* AlertTriangle */1
              }
            });
}

var ConfirmLargeTipAmountsContent = {
  Styles: Styles$2,
  make: WebContainers_BusinessDashboard_ToDo_PayTips$Content$Modals$ConfirmLargeTipAmountsContent
};

var errorText$2 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Red */5,
            _0: /* Medium */2
          }),
      tl: /* [] */0
    });

var Styles$3 = {
  errorText: errorText$2
};

function WebContainers_BusinessDashboard_ToDo_PayTips$Content$Modals$ConfirmPayoutAmountsContent(Props) {
  var hideModal = Props.hideModal;
  var payTips = Props.payTips;
  var tipAmounts = Props.tipAmounts;
  var match = ReactIO.useMappableState(function (param) {
        return Relude_AsyncResult.init;
      });
  var setAsyncPayTipsResult = match[1];
  var asyncPayTipsResult = match[0];
  var payTips$1 = function (tipAmounts) {
    return IOUtils.ioWithStatus(/* Loading */1, (function (asyncResult) {
                  return Relude_IO.flatMap((function (param) {
                                return Relude_AsyncResult.foldByValue(Relude_IO.pure(undefined), (function (param) {
                                              return Relude_IO.flatMap((function (param) {
                                                            return hideModal;
                                                          }), BrowserBindings_ReactHotToast.displayMessage({
                                                              TAG: /* Status */8,
                                                              _0: /* CircleCheckedFilled */5
                                                            }, "Tips were successfully closed out for " + (Relude_Int.toString(Relude_Array.length(tipAmounts)) + " Professional(s).")));
                                            }), (function (param) {
                                              return Relude_IO.pure(undefined);
                                            }), asyncResult);
                              }), Curry._1(setAsyncPayTipsResult, (function (param) {
                                    return Relude_Globals.$$const(asyncResult, param);
                                  })));
                }), Curry._1(payTips, tipAmounts));
  };
  return React.createElement(BrowserComponents_Modal.Message.make, {
              children: React.createElement(BrowserComponents_FlexColumn.make, {
                    children: null
                  }, Relude_Array.mapWithIndex((function (param, rowIndex) {
                          return React.createElement(WebContainers_BusinessDashboard_ToDo_PayTips$Content$WorkerTipsRow, {
                                      rowIndex: rowIndex,
                                      tipAmount: param[1],
                                      workerName: param[0].workerName,
                                      key: Relude_Int.toString(rowIndex)
                                    });
                        }), tipAmounts), Relude_Option.fold(null, (function (param) {
                          return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                          size: /* Large */5
                                        }), React.createElement(BrowserComponents_Text.make, {
                                          className: errorText$2,
                                          children: "Could not pay out tips due to an unexpected error."
                                        }));
                        }), Relude_AsyncResult.getError(asyncPayTipsResult))),
              primaryButton: {
                disabled: Relude_AsyncResult.isBusy(asyncPayTipsResult),
                onClick: payTips$1(Curry._2(Relude_Array.map, (function (param) {
                            return {
                                    tipAmount: param[1],
                                    workerShiftId: param[0].workerShiftId
                                  };
                          }), tipAmounts)),
                title: "Yes, Pay Tips"
              },
              secondaryButton: {
                disabled: Relude_AsyncResult.isBusy(asyncPayTipsResult),
                onClick: hideModal,
                title: "Go Back"
              },
              title: "Are these the correct tip amounts?"
            });
}

var ConfirmPayoutAmountsContent = {
  Styles: Styles$3,
  make: WebContainers_BusinessDashboard_ToDo_PayTips$Content$Modals$ConfirmPayoutAmountsContent
};

function getContent(hideModal, payTips, showModal, tipAmounts, param) {
  if (param) {
    return React.createElement(WebContainers_BusinessDashboard_ToDo_PayTips$Content$Modals$ConfirmPayoutAmountsContent, {
                hideModal: hideModal,
                payTips: payTips,
                tipAmounts: tipAmounts
              });
  } else {
    return React.createElement(WebContainers_BusinessDashboard_ToDo_PayTips$Content$Modals$ConfirmLargeTipAmountsContent, {
                hideModal: hideModal,
                showModal: showModal,
                tipAmounts: tipAmounts
              });
  }
}

var Modals = {
  ConfirmLargeTipAmountsContent: ConfirmLargeTipAmountsContent,
  ConfirmPayoutAmountsContent: ConfirmPayoutAmountsContent,
  getContent: getContent
};

var containsAtLeastOneLargeTipAmount = Reselect.createSelector1(undefined, Relude_Globals.id, Curry._1(WebTypes_ToDo.PayTips.$$Map.any, (function (_key, amount) {
            if (amount) {
              return Curry._2(Relude_Int.OrdNamed.greaterThan, 25000, amount._0);
            } else {
              return false;
            }
          })));

var containsAtLeastOneTipAmountOverMaximumPayout = Reselect.createSelector1(undefined, Relude_Globals.id, Curry._1(WebTypes_ToDo.PayTips.$$Map.any, (function (_key, amount) {
            if (amount) {
              return Curry._2(Relude_Int.OrdNamed.greaterThan, 40000, amount._0);
            } else {
              return false;
            }
          })));

var getSortedPayTipsAmounts = Reselect.createSelector1(undefined, Relude_Globals.id, (function (param) {
        return Relude_Globals.$great$great(WebTypes_ToDo.PayTips.$$Map.toArray, (function (param) {
                      return Relude_Array.sortBy((function (param, param$1) {
                                    var match = param$1[0];
                                    var match$1 = param[0];
                                    var other = Curry._2(CommonTypes_User_Name.compare, match$1.workerName, match.workerName);
                                    if (other === "equal_to") {
                                      return Curry._2(CommonTypes_Worker_Id.compare, match$1.workerId, match.workerId);
                                    } else {
                                      return other;
                                    }
                                  }), param);
                    }), param);
      }));

function WebContainers_BusinessDashboard_ToDo_PayTips$Content(Props) {
  var payTips = Props.payTips;
  var responsiveLayout = Props.responsiveLayout;
  var workers = Props.workers;
  var match = ReactIO.useMappableState(function (param) {
        return Curry._1(WebTypes_ToDo.PayTips.$$Map.make, undefined);
      });
  var setTipAmounts = match[1];
  var tipAmounts = match[0];
  ReactIO.useEffect1(undefined, undefined, (function (workers) {
          var partial_arg = Curry._2(WebTypes_ToDo.PayTips.$$Map.reject, (function (param, param$1) {
                  return Relude_Option.isNone(Curry._2(CommonTypes_WorkerShift.Id.$$Map.get, param.workerShiftId, workers));
                }), tipAmounts);
          return Curry._1(setTipAmounts, (function (param) {
                        return Relude_Globals.$$const(partial_arg, param);
                      }));
        }), workers);
  var arg = Curry._1(getSortedPayTipsAmounts, tipAmounts);
  return React.createElement(BrowserComponents_WithModal.make, {
              children: (function (param, showModal) {
                  return React.createElement(WebComponents_ToDoWorkerShiftList.make, {
                              actionButton: {
                                disabled: Curry._1(WebTypes_ToDo.PayTips.$$Map.isEmpty, tipAmounts) || Curry._1(containsAtLeastOneTipAmountOverMaximumPayout, tipAmounts),
                                onClick: Curry._1(showModal, Curry._1(containsAtLeastOneLargeTipAmount, tipAmounts) ? /* ConfirmLargeTipAmounts */0 : /* ConfirmPayoutAmounts */1),
                                title: "Pay Tips"
                              },
                              children: (function (payTipToDo) {
                                  var partial_arg = Curry._1(WebTypes_ToDo.PayTips.$$Map.remove, payTipToDo);
                                  var partial_arg$1 = function (param) {
                                    return Relude_Option.fold(partial_arg, (function (param) {
                                                  return Relude_Globals.$great$great(CommonTypes_WorkerShift.PayTipsAmountInput.earnedTips, (function (__x) {
                                                                return Curry._2(WebTypes_ToDo.PayTips.$$Map.set, payTipToDo, __x);
                                                              }), param);
                                                }), param);
                                  };
                                  var partial_arg$2 = Relude_Option.keep(Curry._1(Relude_Int.OrdNamed.greaterThan, 0));
                                  var partial_arg$3 = function (param) {
                                    return Relude_Globals.$great$great(partial_arg$2, partial_arg$1, param);
                                  };
                                  return React.createElement(WebContainers_BusinessDashboard_ToDo_PayTips$Content$TipsEarnedInput, {
                                              setTipAmount: (function (param) {
                                                  return Relude_Globals.$great$great(partial_arg$3, setTipAmounts, param);
                                                }),
                                              tipAmount: Curry._2(WebTypes_ToDo.PayTips.$$Map.get, payTipToDo, tipAmounts)
                                            });
                                }),
                              headerChildren: React.createElement(BrowserComponents_Text.make, {
                                    children: "Tip Amount"
                                  }),
                              getKebabMenuActions: (function (payTipToDo) {
                                  var match = Curry._2(WebTypes_ToDo.PayTips.$$Map.get, payTipToDo, tipAmounts);
                                  var tmp;
                                  var exit = 0;
                                  if (match !== undefined && !match) {
                                    tmp = {
                                      icon: {
                                        TAG: /* Status */8,
                                        _0: /* CircleX */11
                                      },
                                      onClick: Curry._1(setTipAmounts, Curry._1(WebTypes_ToDo.PayTips.$$Map.remove, payTipToDo)),
                                      title: "Remove \"No tips earned\""
                                    };
                                  } else {
                                    exit = 1;
                                  }
                                  if (exit === 1) {
                                    tmp = {
                                      icon: {
                                        TAG: /* Status */8,
                                        _0: /* CircleBlock */3
                                      },
                                      onClick: Curry._1(setTipAmounts, Curry._2(WebTypes_ToDo.PayTips.$$Map.set, payTipToDo, /* NoTipsEarned */0)),
                                      title: "Mark no tips earned"
                                    };
                                  }
                                  return [tmp];
                                }),
                              getWorkerId: (function (param) {
                                  return param.workerId;
                                }),
                              getWorkerName: (function (param) {
                                  return param.workerName;
                                }),
                              getWorkerProfilePicture: (function (param) {
                                  return param.workerProfilePicture;
                                }),
                              responsiveLayout: responsiveLayout,
                              title: "Pay Tips",
                              workers: workers
                            });
                }),
              getModalContent: (function (param) {
                  return function (param$1) {
                    return function (param$2) {
                      return getContent(param, payTips, param$1, arg, param$2);
                    };
                  };
                })
            });
}

var Content = {
  maxTipAmountWithoutConfirmation: 25000,
  maxTipPayoutAmount: 40000,
  TipsEarnedInput: TipsEarnedInput,
  WorkerTipsRow: WorkerTipsRow,
  Modals: Modals,
  containsAtLeastOneLargeTipAmount: containsAtLeastOneLargeTipAmount,
  containsAtLeastOneTipAmountOverMaximumPayout: containsAtLeastOneTipAmountOverMaximumPayout,
  getSortedPayTipsAmounts: getSortedPayTipsAmounts,
  make: WebContainers_BusinessDashboard_ToDo_PayTips$Content
};

var header = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.borderBottom(BrowserStyle.rem(0.0625), BrowserStyle.solid, {
              TAG: /* Grey */2,
              _0: /* Lightest */4
            }),
        tl: /* [] */0
      }
    });

function arg$2(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* Large */4, /* Bold */2);
}

var titleContent = Curry._1(BrowserStyle.style, Curry._1(arg$2(undefined), {
          hd: BrowserStyle.flex({
                NAME: "num",
                VAL: 1.0
              }),
          tl: {
            hd: BrowserStyle.justifyContent(BrowserStyle.center),
            tl: {
              hd: BrowserStyle.padding2(BrowserStyle.Spacing.medium, BrowserStyle.zero),
              tl: {
                hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.medium),
                tl: /* [] */0
              }
            }
          }
        }));

var customContent = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.minWidth(BrowserStyle.zero),
        tl: {
          hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.medium),
          tl: /* [] */0
        }
      }
    });

var backButton = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.stretch),
      tl: {
        hd: BrowserStyle.flexShrink(0.0),
        tl: {
          hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.medium),
          tl: {
            hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.medium),
            tl: /* [] */0
          }
        }
      }
    });

var emptyBlockToKeepContentCentered = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flexShrink(0.0),
      tl: {
        hd: BrowserStyle.height(BrowserStyle.zero),
        tl: {
          hd: BrowserStyle.width(BrowserStyle.rem(2.25)),
          tl: /* [] */0
        }
      }
    });

var Styles$4 = {
  header: header,
  titleContent: titleContent,
  customContent: customContent,
  backButton: backButton,
  emptyBlockToKeepContentCentered: emptyBlockToKeepContentCentered
};

function WebContainers_BusinessDashboard_ToDo_PayTips$MobileNavigationHeader(Props) {
  var children = Props.children;
  var onBackPress = Props.onBackPress;
  var tmp;
  tmp = children.TAG === /* Custom */0 ? React.createElement(BrowserComponents_FlexRow.make, {
          className: customContent,
          children: children._0
        }) : React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_FlexRow.make, {
              className: titleContent,
              children: null
            }, React.createElement(BrowserComponents_Text.make, {
                  children: children.title
                }), Relude_Option.fold(null, (function (alertCount) {
                    return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Small */3
                                  }), React.createElement(BrowserComponents_AlertCountIndicator.make, {
                                    alertCount: alertCount
                                  }));
                  }), Relude_Option.keep(Curry._1(Relude_Int.OrdNamed.greaterThan, 0))(children.alertCount))), Relude_Option.isSome(onBackPress) ? React.createElement("div", {
                className: emptyBlockToKeepContentCentered
              }) : null);
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: header,
              children: null
            }, Relude_Option.fold(React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Medium */4
                    }), (function (onBackPress) {
                    return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Button.Base.make, {
                                    children: React.createElement(BrowserComponents_Icon.make, {
                                          icon: {
                                            TAG: /* Small */1,
                                            _0: {
                                              TAG: /* Arrow */0,
                                              _0: /* ChevronLeft */11
                                            }
                                          }
                                        }),
                                    className: backButton,
                                    onClick: (function (param) {
                                        return onBackPress;
                                      })
                                  }), React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* XSmall */2
                                  }));
                  }), onBackPress), tmp);
}

var MobileNavigationHeader = {
  Styles: Styles$4,
  make: WebContainers_BusinessDashboard_ToDo_PayTips$MobileNavigationHeader
};

var getNavigationShifts = Reselect.createSelector1(undefined, Relude_Globals.id, WebTypes_ToDo.Shift.$$Map.keyArray);

var mobileShiftInfoContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.minWidth(BrowserStyle.zero),
          tl: {
            hd: BrowserStyle.paddingBottom(BrowserStyle.Spacing.medium),
            tl: {
              hd: BrowserStyle.paddingTop(BrowserStyle.Spacing.medium),
              tl: /* [] */0
            }
          }
        }
      }
    });

var mobileShiftTypeImage = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(2.0)),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.rem(2.0)),
        tl: /* [] */0
      }
    });

function arg$3(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Medium */3, /* Semibold */1);
}

var mobileShiftIDAndType = Curry._1(BrowserStyle.style, Curry._1(arg$3(undefined, undefined), {
          hd: BrowserStyle.flex({
                NAME: "num",
                VAL: 1.0
              }),
          tl: {
            hd: BrowserStyle.maxWidth(BrowserStyle.pct(100.0)),
            tl: {
              hd: BrowserStyle.overflow(BrowserStyle.hidden),
              tl: {
                hd: BrowserStyle.textOverflow(BrowserStyle.ellipsis),
                tl: {
                  hd: BrowserStyle.whiteSpace(BrowserStyle.nowrap),
                  tl: /* [] */0
                }
              }
            }
          }
        }));

var noTipsToPayContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: /* [] */0
      }
    });

var noTipsTaskCard = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.minWidth(BrowserStyle.rem(23.0)),
      tl: /* [] */0
    });

function arg$4(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XXLarge */6, /* Bold */2);
}

var noTipsTitle = Curry._1(BrowserStyle.style, Curry._1(arg$4(undefined), /* [] */0));

var noTipsDescription = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Grey */2,
            _0: /* Medium */2
          }),
      tl: /* [] */0
    });

var Styles$5 = {
  mobileShiftInfoContainer: mobileShiftInfoContainer,
  mobileShiftTypeImage: mobileShiftTypeImage,
  mobileShiftIDAndType: mobileShiftIDAndType,
  noTipsToPayContainer: noTipsToPayContainer,
  noTipsTaskCard: noTipsTaskCard,
  noTipsTitle: noTipsTitle,
  noTipsDescription: noTipsDescription
};

function WebContainers_BusinessDashboard_ToDo_PayTips(Props) {
  var navigateToPostAShift = Props.navigateToPostAShift;
  var payTips = Props.payTips;
  var payTipsAlertCount = Props.payTipsAlertCount;
  var payTipsToDos = Props.payTipsToDos;
  var responsiveLayout = Props.responsiveLayout;
  var selectedShiftId = Props.selectedShiftId;
  var setView = Props.setView;
  return React.createElement(React.Fragment, undefined, responsiveLayout >= 2 ? (
                Curry._1(WebTypes_ToDo.Shift.$$Map.isEmpty, payTipsToDos) ? React.createElement(BrowserComponents_FlexColumn.make, {
                        className: noTipsToPayContainer,
                        children: null
                      }, React.createElement(BrowserComponents_Spacer.make, {
                            size: /* XXXLarge */8
                          }), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* XXLarge */7
                          }), React.createElement(BrowserComponents_Image.make, {
                            image: {
                              TAG: /* Illustration */1,
                              _0: /* Congrats */22
                            }
                          }), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* Medium */4
                          }), React.createElement(BrowserComponents_Text.make, {
                            className: noTipsTitle,
                            children: "Awesome!"
                          }), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* Small */3
                          }), React.createElement(BrowserComponents_Text.make, {
                            className: noTipsDescription,
                            children: "You have no outstanding tips."
                          }), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* XXLarge */7
                          }), React.createElement(WebComponents_ToDoTaskCard.make, {
                            alertCount: 0,
                            className: noTipsTaskCard,
                            description: "Add a shift to your schedule.",
                            illustration: /* Professionals */73,
                            onClick: Curry._1(navigateToPostAShift, undefined),
                            title: "Post a Shift"
                          })) : React.createElement(WebComponents_ToDoShiftNavigation.make, {
                        clearSelectedShift: Curry._1(setView, Relude_Option.pure(Curry._1(WebTypes_View.BusinessDashboard.ToDo.payTips, undefined))),
                        getAlertCountForShift: (function (param) {
                            return Relude_Globals.$great$great((function (__x) {
                                          return Curry._2(WebTypes_ToDo.Shift.$$Map.get, __x, payTipsToDos);
                                        }), (function (param) {
                                          return Relude_Option.fold(0, Relude_Map.length, param);
                                        }), param);
                          }),
                        onShiftNavigation: (function (param) {
                            return Relude_Globals.$great$great((function (param) {
                                          return Relude_Globals.$great$great((function (param) {
                                                        return Relude_Globals.$great$great(Relude_Option.pure, WebTypes_View.BusinessDashboard.ToDo.payTips, param);
                                                      }), Relude_Option.pure, param);
                                        }), setView, param);
                          }),
                        selectedShiftId: selectedShiftId,
                        shifts: getNavigationShifts(payTipsToDos)
                      })
              ) : null, Relude_Option.fold(responsiveLayout >= 2 ? null : React.createElement(React.Fragment, undefined, React.createElement(WebContainers_BusinessDashboard_ToDo_PayTips$MobileNavigationHeader, {
                            children: {
                              TAG: /* Title */1,
                              alertCount: payTipsAlertCount,
                              title: "Pay Tips"
                            },
                            onBackPress: Curry._1(setView, undefined)
                          }), React.createElement(WebComponents_ToDoShiftNavigation.make, {
                            clearSelectedShift: Curry._1(setView, Relude_Option.pure(Curry._1(WebTypes_View.BusinessDashboard.ToDo.payTips, undefined))),
                            getAlertCountForShift: (function (param) {
                                return Relude_Globals.$great$great((function (__x) {
                                              return Curry._2(WebTypes_ToDo.Shift.$$Map.get, __x, payTipsToDos);
                                            }), (function (param) {
                                              return Relude_Option.fold(0, Relude_Map.length, param);
                                            }), param);
                              }),
                            onShiftNavigation: (function (param) {
                                return Relude_Globals.$great$great((function (param) {
                                              return Relude_Globals.$great$great((function (param) {
                                                            return Relude_Globals.$great$great(Relude_Option.pure, WebTypes_View.BusinessDashboard.ToDo.payTips, param);
                                                          }), Relude_Option.pure, param);
                                            }), setView, param);
                              }),
                            selectedShiftId: selectedShiftId,
                            shifts: getNavigationShifts(payTipsToDos)
                          })), (function (param) {
                    var workers = param[1];
                    var match = param[0];
                    var match$1 = match.shiftType;
                    var shiftId = match.id;
                    return React.createElement(React.Fragment, undefined, responsiveLayout >= 2 ? null : React.createElement(WebContainers_BusinessDashboard_ToDo_PayTips$MobileNavigationHeader, {
                                      children: {
                                        TAG: /* Custom */0,
                                        _0: React.createElement(BrowserComponents_FlexRow.make, {
                                              className: mobileShiftInfoContainer,
                                              children: null
                                            }, React.createElement(BrowserComponents_Icon.make, {
                                                  className: mobileShiftTypeImage,
                                                  color: {
                                                    TAG: /* Grey */2,
                                                    _0: /* Dark */1
                                                  },
                                                  icon: {
                                                    TAG: /* Large */0,
                                                    _0: {
                                                      TAG: /* ShiftTypeCategory */2,
                                                      _0: match$1.category
                                                    }
                                                  }
                                                }), React.createElement(BrowserComponents_Spacer.make, {
                                                  size: /* Large */5
                                                }), React.createElement(BrowserComponents_Text.make, {
                                                  className: mobileShiftIDAndType,
                                                  children: "#" + (Curry._1(CommonTypes_Shift.Id.toString, shiftId) + (" " + match$1.name))
                                                }), React.createElement(BrowserComponents_Spacer.make, {
                                                  size: /* Small */3
                                                }), React.createElement(BrowserComponents_AlertCountIndicator.make, {
                                                  alertCount: Relude_Map.length(workers),
                                                  theme: {
                                                    backgroundColor: {
                                                      TAG: /* Grey */2,
                                                      _0: /* Dark */1
                                                    },
                                                    textColor: {
                                                      TAG: /* White */7,
                                                      _0: /* Light */2
                                                    }
                                                  }
                                                }))
                                      },
                                      onBackPress: Curry._1(setView, Relude_Option.pure(/* PayTips */{
                                                _0: undefined
                                              }))
                                    }), React.createElement(WebContainers_BusinessDashboard_ToDo_PayTips$Content, {
                                    payTips: payTips,
                                    responsiveLayout: responsiveLayout,
                                    workers: workers,
                                    key: Curry._1(CommonTypes_Shift.Id.toString, shiftId)
                                  }));
                  }), Curry._2(Relude_Option.flatMap, (function (selectedShiftId) {
                        return Curry._2(WebTypes_ToDo.Shift.$$Map.find, (function (param, param$1) {
                                      return Curry._2(CommonTypes_Shift.Id.eq, selectedShiftId, param.id);
                                    }), payTipsToDos);
                      }), selectedShiftId)));
}

var make = WebContainers_BusinessDashboard_ToDo_PayTips;

exports.Content = Content;
exports.MobileNavigationHeader = MobileNavigationHeader;
exports.getNavigationShifts = getNavigationShifts;
exports.Styles = Styles$5;
exports.make = make;
/* container Not a pure module */
